import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { taxSettingCreate } from '../../../redux/actions/taxSettings';

const NewTaxSettingModal = ({ payload, showNewTaxSettingModal, setShowNewTaxSettingModal, newTaxSetting }) => {
  const [taxName, setTaxName] = useState(null);
  const [taxRate, setTaxRate] = useState(null);
  const [code, setCode] = useState(null);

  const create = () => {
    newTaxSetting(payload, taxSetting());
    setShowNewTaxSettingModal(false);
  }

  const taxSetting = () => {
    return {
      rate: taxRate,
      code: code,
      tax_name: taxName,
      type: 'purchase',
    }
  }

  const changeRate = (event) => {
    let value = event.target.value;
    setTaxRate(value);
  }

  const changeName = (event) => {
    let value = event.target.value;
    setTaxName(value);
  }

  const changeCode = (event) => {
    let value = event.target.value;
    setCode(value);
  }

  return(
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowNewTaxSettingModal(false),
          },
          { text: 'New Tax Setting', onClick: () => create() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="New Tax Setting"
        isOpen={showNewTaxSettingModal}
        onClose={() => setShowNewTaxSettingModal(false)}
      >
        <H3>New Tax Setting</H3>
        <Input
          description="Tax Name"
          label="Tax Name"
          onChange={changeName}
          placeholder="Tax Name"
          type="text"
          value={taxName}
          required
        />

        <Input
          description="Tax Rate (%)"
          label="Tax Rate (%)"
          onChange={changeRate}
          placeholder="Tax Rate (%)"
          type="number"
          min="0"
          value={taxRate}
          required
        />

        <Input
          description="Code"
          label="Code"
          onChange={changeCode}
          placeholder="Code"
          type="text"
          value={code}
          required
        />
      </Modal>
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  newTaxSetting: (payload, taxSetting) => dispatch(taxSettingCreate(payload, taxSetting)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewTaxSettingModal);